export const BillingApiPath = {
  LIST_BILLING: '/api/billing', // GET List Billing
  CREATE_BILLING: '/api/billing', // POST Create Billing
  UPDATE_BILLING: '/api/billing/{billing_id}', // PATCH Update Billing
  USAGE_BY_SITE: '/api/billing/usage-by-site', // GET Usage By Site
  USAGE_BY_SITE_EXCEL: '/api/billing/usage-by-site/excel' // GET Usage By Site Excel
}

export type BillingApiPath = (typeof BillingApiPath)[keyof typeof BillingApiPath]

export interface ListBillingVars {
  site_id?: number | null
  status?: string | null
  page?: number
  per_page?: number
}

export interface CreateBillingVars {
  site_id: number
  billing_month: string
  plan_name?: string | null
  base_amount?: number
  usage_amount?: number
  notes?: string | null
}

export interface UpdateBillingVars {
  billing_id: number
  plan_name?: string | null
  base_amount?: number | null
  usage_amount?: number | null
  status?: string | null
  invoice_url?: string | null
  notes?: string | null
}

import { BillingRecord } from '@/common/model/ugcBilling'

export interface ListBillingResponse {
  items: BillingRecord[]
  total: number
}

export interface CreateBillingResponse {
  id: number
}

export interface UpdateBillingResponse {
  ok: boolean
}

export interface UsageBySiteVars {
  month?: string | null
}

export interface SiteUsageRow {
  site_id: number
  site_name: string
  data_integration: number
  data_retention: number
  mu: number
  reco_media_tag: number
  reco_media_delivery: number
  article_feature_pages: number
  article_create: number
  article_upload: number
  geo_llmo: number
  review: number
  ai_purchase_assist: number
  ai_purchase_conversation: number
  search_suggest_usage: number
  /** Tag Trail。有効タグ数だけ現時点のスナップショットで、他2つは選択月の実測 */
  tag_active: number
  tag_impressions: number
  tag_page_views: number
  carte: number
  /** AIペルソナ。LLMを使わないため件数のみ。いずれも現時点のスナップショット */
  persona_judged_customers: number
  persona_adopted: number
  /** 商品意味理解。費用が直接出る唯一のサービスなので金額も持つ */
  pu_products: number
  pu_tokens: number
  pu_cost_usd: number
}

export interface UsageBySiteResponse {
  month: string
  sites: SiteUsageRow[]
}
